import { useCallback } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { CollectionsFieldsEditor } from "@/components/custom-fields/collections-fields-editor/index";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { CollectionConfigDialog } from "@/components/collections/config/collection-config-dialog";

export const Route = createFileRoute("/_authenticated/settings/_layout/collections/config/$collectionId")({
  // `?branch=`: sucursal de los valores (por sucursal). Sin ella, la activa.
  validateSearch: z.object({ branch: z.string().optional() }),
  component: CollectionConfigValuesPage,
});

/**
 * Valores de una colección de configuración: Configuración → Colecciones con
 * esa colección elegida y el diálogo de su registro encima (cerrarlo deja la
 * colección abierta). La ruta propia deja enlazar y redirigir aquí desde
 * `/collections/$collectionId`.
 */
function CollectionConfigValuesPage() {
  const { collectionId } = Route.useParams();
  const { branch } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const close = useCallback(
    () => void navigate({ to: "/settings/collections", search: { table: collectionId } }),
    [navigate, collectionId],
  );
  return (
    <RouteGuardPermissions permissions={[{ module: "custom_fields", actions: ["read"] }]}>
      <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-hidden">
        <CollectionsFieldsEditor
          initialTable={collectionId}
          onSelectionChange={(key) => {
            if (key && key !== collectionId) void navigate({ to: "/settings/collections", search: { table: key } });
          }}
        />
      </div>
      <CollectionConfigDialog
        collectionId={collectionId}
        branchId={branch}
        onBranchChange={(next) => void navigate({ search: { branch: next }, replace: true })}
        onClose={close}
      />
    </RouteGuardPermissions>
  );
}
